import { localStorage } from 'dibs-browser-storage';

export const setPromoCodeNotificationShown = promoCode => {
    localStorage.setItem(promoCode.serviceId, true);
};

export const wasPromoCodeNotificationShown = promoCode =>
    !!localStorage.getItem(promoCode.serviceId);
